import { useEffect } from 'react';

import { useBlocker } from 'react-router-dom';

export const useUnsavedChanges = (hasUnsavedChanges, message) => {
  useBlocker(() => {
    if (hasUnsavedChanges) {
      const confirmLeave = window.confirm(message);
      return !confirmLeave;
    }
    return false;
  });

  useEffect(() => {
    const handleBeforeUnload = (e) => {
      if (hasUnsavedChanges) {
        e.preventDefault();
        e.returnValue = message; // Browser-specific requirement
      }
    };

    if (hasUnsavedChanges) {
      window.addEventListener('beforeunload', handleBeforeUnload);
    }

    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload);
    };
  }, [hasUnsavedChanges, message]);
};
